<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <router-link to="/new-game" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></router-link>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Start scholar test</h1>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
          <avatar>Select game type</avatar>

            <form>
                <input type="text" class="form-control mb--md" v-model="name" placeholder="Room name" />

                <select class="form-control mb--md" v-model="level">
                    <option value="0" disabled selected>Room level</option>
                    <option value="1">Level 1</option>
                    <option value="2">Level 2</option>
                    <option value="3">Level 3</option>
                    <option value="4">Level 4</option>
                </select>

                <select class="form-control mb--md" v-model="category">
                    <option value="" selected>All categories</option>
                    <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                </select>

                <button type="button" @click="create" class="btn btn--block btn--purple">Create room</button>
            </form>
        </section>

        <modal show="false" type="error" ref="validationModal">
            <template v-slot:message>
                <div v-if="errors.any()">
                    <div v-for="error in errors.all()">{{ error }}</div>
                </div>
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
        <modal show="false" type="error" ref="permissionModal">
            <template v-slot:message>
                you don't have permission to access this feature!
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </div>
</template>

<script>
    import Errors from "../../../util/Errors"
    import api from "../../../api/scholar"

    export default {

        data: function () {
            return {
                categories: null,
                name: null,
                level: null,
                category: '',
                errors: new Errors()
            }
        },

        methods: {
            async create() {
                try {
                    let response = await api.createRoom(this.name, this.level, this.category)

                    Quiz.$emit('scholar-room-created', response.data.data)
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errors.record(error.response.data.errors)
                        this.$refs.validationModal.open()
                    }

                    if (error.response.status === 403) {
                        this.$refs.permissionModal.open()
                    }
                }
            },

            async loadCategories() {
                let response = await api.getCategories()

                this.categories = response.data.data
            }
        },

        created() {
            this.loadCategories()
        }
    }
</script>

<style scoped>

</style>